import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
import DocStore from "../../pages/ordersSummary/DocStore.json";
// initial state
export const initialState = {
  loading: false,
  error: null,
  success: null,
  MissingInfos: null,
  DocStoreDetails: {},
  editOrderDetails: null,
  checkListDetails: null,
  users: [],
  IDVBorrowerDetails:null,
  isCurrentFirmPromptFinancial: null,
  IDVFinalResultReviewdByCTIC: null,
};
// our slice
const orderSummarySlice = createSlice({
  name: "orderSummary",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    getMissingInfos: (state, { payload }) => {
      state.loading = false;
      state.MissingInfos = payload;
      state.error = null;
    },

    getEmailDetails: (state, { payload }) => {
      state.loading = false;
      state.EmailIds = payload;
      state.error = null;
    },
    getOrderDetails: (state, { payload }) => {
      state.loading = false;
      state.EmailIds = payload;
      state.error = null;
    },
    getInvoiceDetails: (state, { payload }) => {
      state.loading = false;
      state.EmailIds = payload;
      state.error = null;
    },

    getDocStoreInfo: (state, { payload }) => {
      const allDocs = [...payload];
      const allUsers = extractUsers(allDocs);
      if (allUsers) {
        state.users = allUsers;
      }
      state.loading = false;
      state.DocStoreDetails.DocStore = payload;
      state.error = null;
    },
    setEditOrderDetails: (state, { payload }) => {
      state.editOrderDetails = payload;
    },
    setCheckListDetails: (state, { payload }) => {
      state.checkListDetails = payload;
    },
    setIDVBorrowerDetails: (state, { payload }) => {
      state.IDVBorrowerDetails = payload;
    },
    setIsCurrentFirmPromptFinancial: (state, { payload }) => {
      state.isCurrentFirmPromptFinancial = payload;
    },
    setIDVFinalResultReviewdByCTIC: (state, { payload }) => {
      state.IDVFinalResultReviewdByCTIC = payload;
    },
  },
});
// export the actions
export const {
  setLoading,
  getMissingInfos,
  getDocStoreInfo,
  getEmailDetails,
  getOrderDetails,
  getInvoiceDetails,
  setError,
  setSuccess,
  setEditOrderDetails,
  setCheckListDetails,
  setIDVBorrowerDetails,
  setIsCurrentFirmPromptFinancial,
  setIDVFinalResultReviewdByCTIC
} = orderSummarySlice.actions;

// export the default reducer
export default orderSummarySlice.reducer;

// export the selector for fetching the global state
export const orderSummarySelector = (state) => state.orderSummary;

// Get Province API call
const extractUsers = (docs) => {
  const allUsers = [];

  docs.forEach((doc) => {
    if (!allUsers.includes(doc.addedByUserName)) {
      allUsers.push(doc.addedByUserName);
    }
  });

  return allUsers;
};

export const GetMissingInfoDetails = (fileid, language) => async (dispatch) => {
  try {
    dispatch(setLoading());

    var req = {
      fileID: fileid,
      language: language,
    };
    let result = await http.post("Order/GetMissingInfoForFile", req);
    dispatch(getMissingInfos(result.data.missingList || []));
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetEmailDetails = (fileid) => async (dispatch) => {
  try {
    dispatch(setLoading());

    dispatch(getEmailDetails(DocStore));
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetOrderDetails = (fileid) => async (dispatch) => {
  try {
    dispatch(setLoading());

    dispatch(getOrderDetails(DocStore));
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetInvoiceDetails = (fileid) => async (dispatch) => {
  try {
    dispatch(setLoading());

    dispatch(getInvoiceDetails(DocStore));
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetDocStoreDetails = (fileID, UserID) => async (dispatch) => {
  try {
    if (fileID === undefined || fileID === 0) return;
    dispatch(setLoading());
    let request = {
      FileID: fileID,
    };
    let data = { UserID: UserID, RequestObject: request };
    const results = await http
      .post("Document/GetStorageFiles", data)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setSuccess());
      dispatch(getDocStoreInfo(results.data.responseObject.storageList));
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const UploadDocument = (data) => async (dispatch) => {
  try {
    dispatch(setLoading());
    var reqData = {
      PropertyID: data.Property,
      DocumentType: data.DocumentType,
    };
    let Base64String = await convertToBase64(val[0]);
    Base64String = formatDocumentUploadBase64StringByDocumentType(val[0]?.type, Base64String)
    let req = {};
    req.FileID = postOrderDetailsInfo?.fileID;
    req.DocumentFileName = val[0].name;
    req.DocumentRawStream = Base64String;
    req.UserID = userLogin.userId;
    req.IsPublic = false;
    req.DocumentType = data.DocumentType;
    req.propertyID = data.Property;
    req.SectionName = "PropertyIdentifier";
    req.FileNumber = postOrderDetailsInfo?.fileNumber;
    req.Notes = "";
    req.DocStoreId = 1;
    //setBase64(Base64String);
    dispatch(
      UploadDocumentExpress(req, formApiName, val[0].name, name, {
        setValue,
        trigger,
        field,
      })
    );
    // Make API call for registration
    // const { data: response } =await http.post(
    //   "order/SaveDocuments",
    //   reqData
    // );
    // if (response.responseCode == 0) {
    //   dispatch(setSuccess());

    // }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetEditOrderDetails = (FileID, UserID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      FileID: FileID,
    };

    let req = { UserID: UserID, RequestObject: request };
    const results = await http
      .post("Order/GetAllFileDetailsByFileId", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setEditOrderDetails(results.data.responseObject));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
  
export const GetIsCurrentFirmPromptFinancial = (firmId) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      FirmID: Number(firmId),
    };

    let req = { RequestObject: request };
    const results = await http
      .post("lawfirm/GetIsCurrentFirmPromptFinancial", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setIsCurrentFirmPromptFinancial(results.data.responseObject?.isPromptFinancial));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetIDVFinalResultReviewdByCTIC = (FileID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      fileID: FileID,
    };

    let req = { RequestObject: request };
    const results = await http
      .post("order/GetIDVFinalResultReviewdByCTICExpress", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setIDVFinalResultReviewdByCTIC(results.data.responseObject?.result));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetIDVBorrowerDetails = (FileID, UserID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      fileID: FileID,
    };

    let req = { UserID: UserID, RequestObject: request };
    const results = await http
      .post("Order/GetBorrowerDetailswithIDVAddressFileExpress", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setIDVBorrowerDetails(results.data.responseObject));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetAllCheckList = (FileID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      FileID: FileID,
    };

    let req = { RequestObject: request };
    const results = await http
      .post("Order/GetAllCheckList", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setCheckListDetails(results.data.responseObject));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};
